import script from "./ContactsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactsView.vue?vue&type=script&setup=true&lang=js"

import "./ContactsView.vue?vue&type=style&index=0&id=4a4da3f2&lang=scss"

const __exports__ = script;

export default __exports__